import React, { useMemo } from 'react';
import faqData_es from './data/faqData_es';
import faqData_en from './data/faqData_en';
import faqData_pt from './data/faqData_pt';

const getFaqData = (lang) => {
  switch (lang) {
    case 'en': return faqData_en;
    case 'pt': return faqData_pt;
    case 'es':
    default: return faqData_es;
  }
};

export default function FAQcontent({ language = 'es' }) {
  const faqData = useMemo(() => getFaqData(language), [language]);

  return (
    <section id="faqc" className="py-12 px-6 max-w-4xl mx-auto">
      {faqData.map((section, index) => (
        <div key={index} className="mb-8">
          <h4 className="text-xl font-semibold mb-4">{section.category}</h4>
          {section.questions.map((item, i) => (
            <details key={i} className="mb-3">
              <summary className="cursor-pointer font-medium text-gray-800 hover:text-[#48887B]">{item.q}</summary>
              <p className="mt-2 text-sm text-gray-700 leading-relaxed">{item.a}</p>
            </details>
          ))}
        </div>
      ))}
    </section>
  );
}
